import React from 'react';

import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'styled-components';

import { ArticleDate } from 'components/ArticleDate';
import Link from 'components/Link';

import { BlogPostI } from 'interfaces/content-stack/blogPost';

import { buildBreadcrumbUrls } from 'utils/functions';

const RecentArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 3rem;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding-top: 0;
  }
`;

const Header = styled.div`
  font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: 500;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const RecentArticleEntry = styled.div`
  padding-bottom: 1rem;
  border-bottom: solid 1px ${(props) => props.theme.colors.secondaryGray2};
  margin-bottom: 1.5rem;
`;

const ArticleTitle = styled(Link)`
  font-weight: 600;
  text-decoration: none;
  display: block;
  color: inherit;
  font-family: ${(props) => props.theme.fonts.default};

  &:hover {
    color: ${(props) => props.theme.colors.primaryRed};
  }
`;

const SeeMoreButton = styled(Link)`
  text-decoration: none;
  color: inherit;
  font-weight: 600;
  font-family: ${(props) => props.theme.fonts.default};
  display: inline-flex;
  align-items: center;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${(props) => props.theme.colors.primaryRed};
  }

  svg {
    color: ${(props) => props.theme.colors.primaryRed};
    font-size: 0.65rem;
  }
`;

const RecentArticles = ({ articles, allArticles }: { articles: BlogPostI[]; allArticles: string }) => {
  return (
    <RecentArticlesContainer>
      <Header>Recent Articles</Header>
      <div>
        {articles.map((article, i) => {
          const { breadcrumb, postDate, title, url } = article;

          return (
            <RecentArticleEntry key={i}>
              <ArticleDate date={postDate} />
              <ArticleTitle to={buildBreadcrumbUrls(breadcrumb, url)}>{title}</ArticleTitle>
            </RecentArticleEntry>
          );
        })}

        <SeeMoreButton to={allArticles}>
          See more&nbsp;&nbsp;
          <FontAwesomeIcon icon={faArrowRightLong} />
        </SeeMoreButton>
      </div>
    </RecentArticlesContainer>
  );
};

export default RecentArticles;
